// extracted by mini-css-extract-plugin
module.exports = {"advContainer":"index-module_advContainer_1-5cp"};